<template>
  <div>
    <a-spin :spinning="loading">
      <a-form-model :model="iPlano" :rules="formRules" v-bind="fiOptions"
                    @submit.native.prevent @submit="guardar" ref="datos_iPlanoles">
        <a-tabs :active-key="keyTab" @change="changeTab">
          <a-tab-pane key="0" force-render>
          <span slot="tab">
            <a-icon type="idcard"/>
            Datos Personales
          </span>
            <a-row :gutter="[16,2]">
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Compañia')" prop="company" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.company"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Primer nombre')" prop="name1" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.name1"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Segundo nombre')" prop="name2" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.name2"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Primer apellido')" prop="last_name1" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.last_name1"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Segundo apellido')" prop="last_name2" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.last_name2"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Tipo Doc.')" prop="tipo_doc" has-feedback>
                  <form-model-dropdown :disabled="readonlyInput" style="width: 100%"
                                       v-model="iPlano.tipo_doc"
                                       endpoint="hierarchy_lookup"
                                       :params="request.tipo_documento"
                  ></form-model-dropdown>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('IdPerson')" prop="id_person" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.id_person"></a-input>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Codigo')" prop="integral" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.id_emp"></a-input>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Integral')" prop="integral" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           readOnly
                           v-model="iPlano.integral"></a-input>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Año')" prop="year" has-feedback>
                  <a-input-number :disabled="readonlyInput" style="width: 100%"
                                  v-model="iPlano.year"></a-input-number>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Mes')" prop="month" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.month"></a-input>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Ingresos del mes')" prop="secuenciasecuencia" has-feedback>
                  <a-input-number :disabled="readonlyInput" style="width: 100%"
                                  v-model="iPlano.secuenciasecuencia"
                                  :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                  :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                  >
                  </a-input-number>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Salario')" prop="salario" has-feedback>
                  <a-input-number :disabled="readonlyInput" style="width: 100%"
                                  v-model="iPlano.salario"
                                  :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                  :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                  ></a-input-number>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Tipo Registro')" prop="tipo_registro" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.tipo_registro"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Tipo Cotizante')" prop="tipo_cotizante" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.tipo_cotizante"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Subtipo Cotizante')" prop="subtipo_cotizante" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.subtipo_cotizante"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Horas Laboradas')" prop="horas_labor" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.horas_labor"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Fecha Radicar Extension')" prop="fecha_rad_ext" has-feedback>
                  <a-date-picker :disabled="readonlyInput" style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-model="iPlano.fecha_rad_ext"/>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-tab-pane>

          <a-tab-pane key="1" force-render>
          <span slot="tab">
            <a-icon type="gift"/>
            Novedades
          </span>
            <select-novedades :readOnly="visibleButton" :iPlano="iPlano"/>
          </a-tab-pane>

          <a-tab-pane key="2" force-render>
          <span slot="tab">
            <a-icon type="dollar"/>
            Pensiones
          </span>
            <a-row :gutter="[16,16]" :md="12" :xs="24">
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Afp')" prop="afp" has-feedback>
                  <form-model-dropdown :disabled="readonlyInput" style="width: 100%"
                                       v-model="iPlano.afp"
                                       endpoint="legal_entities"
                                       :params="request.afp"
                  ></form-model-dropdown>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Dias AFP')" prop="dias_afp" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.dias_afp"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('IBC AFP')" prop="ibc_afp" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.ibc_afp"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Tarifa AFP')" prop="tarifa_afp" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.tarifa_afp"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Aporte AFP')" prop="aporte_afp" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.aporte_afp"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Valor Nomina Afp')" prop="valor_nomina_afp" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.valor_nomina_afp"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Aporte empresa AFP')" prop="aporte_empresa_afp" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.aporte_empresa_afp"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Total Afp')" prop="total_afp" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.total_afp"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Aporte solidaridad')" prop="aporte_solid" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.aporte_solid"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Aporte subcuenta')" prop="aporte_subcta" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.aporte_subcta"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Valor Nomina Solid')" prop="valor_nomina_solid" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.valor_nomina_solid"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Valor Nomina Subcta')" prop="valor_nomina_subcta" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.valor_nomina_subcta"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Diferencia solidaridad')" prop="diferencia_solid" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.diferencia_solid"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Afp tras')" prop="afptras" has-feedback>
                  <form-model-dropdown :disabled="readonlyInput" style="width: 100%"
                                       v-model="iPlano.afptras"
                                       endpoint="legal_entities"
                                       :params="request.afp"
                  ></form-model-dropdown>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-tab-pane>

          <a-tab-pane key="3" force-render>
          <span slot="tab">
            <a-icon type="heart"/>
            Salud
          </span>
            <a-row :gutter="[16,16]" :md="12" :xs="24">
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Eps')" prop="eps" has-feedback>
                  <form-model-dropdown :disabled="readonlyInput" style="width: 100%"
                                       v-model="iPlano.eps"
                                       endpoint="legal_entities"
                                       :params="request.eps"
                  ></form-model-dropdown>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Dias EPS')" prop="dias_eps" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.dias_eps"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('IBC EPS')" prop="ibc_eps" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.ibc_eps"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Tarifa EPS')" prop="tarifa_eps" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.tarifa_eps"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Aporte EPS')" prop="aporte_eps" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.aporte_eps"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Valor Nomina Eps')" prop="valor_nomina_eps" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.valor_nomina_eps"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Aporte empresa EPS')" prop="aporte_empresa_eps" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.aporte_empresa_eps"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Valor UPC')" prop="valor_upc" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.valor_upc"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('UpcTipoDoc')" prop="upc_tipo_doc" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.upc_tipo_doc"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('UpcNumDoc')" prop="upc_num_doc" has-feedback>
                  <a-input :disabled="readonlyInput" style="width: 100%"
                           v-model="iPlano.upc_num_doc"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Eps tras')" prop="epstras" has-feedback>
                  <form-model-dropdown :disabled="readonlyInput" style="width: 100%"
                                       v-model="iPlano.epstras"
                                       endpoint="legal_entities"
                                       :params="request.eps"
                  ></form-model-dropdown>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-tab-pane>

          <a-tab-pane key="4" force-render>
          <span slot="tab">
            <a-icon type="alert"/>
            Riesgos
          </span>
            <a-card>
              <a-row :gutter="[16,16]" :md="12" :xs="24">
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Dias ARP')" prop="dias_arp" has-feedback>
                    <a-input :disabled="readonlyInput" style="width: 100%"
                             v-model="iPlano.dias_arp"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('IBC ARP')" prop="ibc_arp" has-feedback>
                    <a-input :disabled="readonlyInput" style="width: 100%"
                             v-model="iPlano.ibc_arp"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Tarifa ARP')" prop="tarifa_arp" has-feedback>
                    <a-input :disabled="readonlyInput" style="width: 100%"
                             v-model="iPlano.tarifa_arp"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Centro trabajo')" prop="centro_trabajo" has-feedback>
                    <a-input :disabled="readonlyInput" style="width: 100%"
                             v-model="iPlano.centro_trabajo"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Aporte ARP')" prop="aporte_arp" has-feedback>
                    <a-input :disabled="readonlyInput" style="width: 100%"
                             v-model="iPlano.aporte_arp"></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-card>
          </a-tab-pane>

          <a-tab-pane key="5" force-render>
          <span slot="tab">
            <a-icon type="appstore"/>
            Parafiscales
          </span>
            <a-card>
              <a-row :gutter="[16,16]" :md="12" :xs="24">
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('CCF')" prop="ccf" has-feedback>
                    <form-model-dropdown :disabled="readonlyInput" style="width: 100%"
                                         v-model="iPlano.ccf"
                                         endpoint="legal_entities"
                                         :params="request.ccf"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Dias CCF')" prop="dias_ccf" has-feedback>
                    <a-input :disabled="readonlyInput" style="width: 100%"
                             v-model="iPlano.dias_ccf"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('IBC CCF')" prop="ibc_ccf" has-feedback>
                    <a-input :disabled="readonlyInput" style="width: 100%"
                             v-model="iPlano.ibc_ccf"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Tarifa CCF')" prop="tarifa_ccf" has-feedback>
                    <a-input :disabled="readonlyInput" style="width: 100%"
                             v-model="iPlano.tarifa_ccf"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Aporte CCF')" prop="aporte_ccf" has-feedback>
                    <a-input :disabled="readonlyInput" style="width: 100%"
                             v-model="iPlano.aporte_ccf"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Tarifa Sena')" prop="tarifa_sena" has-feedback>
                    <a-input :disabled="readonlyInput" style="width: 100%"
                             v-model="iPlano.tarifa_sena"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Aporte SENA')" prop="aporte_sena" has-feedback>
                    <a-input :disabled="readonlyInput" style="width: 100%"
                             v-model="iPlano.aporte_sena"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Tarifa ICBF')" prop="tarifa_icbf" has-feedback>
                    <a-input :disabled="readonlyInput" style="width: 100%"
                             v-model="iPlano.tarifa_icbf"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Aporte ICBF')" prop="aporte_icbf" has-feedback>
                    <a-input :disabled="readonlyInput" style="width: 100%"
                             v-model="iPlano.aporte_icbf"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Ley1607 Exo')" prop="ley1607_exo" has-feedback>
                    <form-model-dropdown :disabled="readonlyInput" style="width: 100%"
                                         v-model="iPlano.ley1607_exo"
                                         endpoint="hierarchy_lookup"
                                         :params="request.estado_sn"
                    ></form-model-dropdown>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Otros parafiscales')" prop="ibcotro_paraf" has-feedback>
                    <a-input :disabled="readonlyInput" style="width: 100%"
                             v-model="iPlano.ibcotro_paraf"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Tarifa ESAP')" prop="tarifa_afp" has-feedback>
                    <a-input :disabled="readonlyInput" style="width: 100%"
                             v-model="iPlano.tarifa_esap"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Aporte ESAP')" prop="aporte_afp" has-feedback>
                    <a-input :disabled="readonlyInput" style="width: 100%"
                             v-model="iPlano.aporte_esap"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Tarifa MEN')" prop="tarifa_afp" has-feedback>
                    <a-input :disabled="readonlyInput" style="width: 100%"
                             v-model="iPlano.tarifa_men"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col v-bind="colSpan">
                  <a-form-model-item :label="$t('Aporte MEN')" prop="aporte_afp" has-feedback>
                    <a-input :disabled="readonlyInput" style="width: 100%"
                             v-model="iPlano.aporte_men"></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-card>
          </a-tab-pane>
        </a-tabs>
        <div v-if="visibleButton">
          <a-card v-if="canEdit" style="text-align: right" :bodyStyle="{padding: '12px 24px'}">
            <a-button
              type="primary"
              html-type="submit">
              Guardar Cambios
            </a-button>
          </a-card>
        </div>
      </a-form-model>
    </a-spin>
  </div>
</template>
<script>
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    props: {
      iPlano: {},
      canEdit: {
        type: Boolean,
        default: false
      },
      endpoint: '',
      visibleButton: false,
      readonlyInput: false
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.initFormRules()
    },
    data () {
      return {
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        keyTab: '0',
        loading: false,
        formRules: {},
        colSpan: {
          xs: 24,
          md: 8
        },
        request: {
          tipo_documento: {
            h_lookup_type: 'TIPO_DOCUMENTO',
            use_code: true
          },
          estado_sn: {
            h_lookup_type: 'ESTADO_SN',
            use_code: true
          },
          afp: {
            ent_type: 'AFP',
            use_ent_id: true
          },
          eps: {
            ent_type: 'EPS',
            use_ent_id: true
          },
          ccf: {
            ent_type: 'PAR',
            use_ent_id: true
          }
        }
      }
    },
    methods: {
      changeTab (e) {
        this.keyTab = e
      },
      guardar () {
        if (this.loading) return
        this.$refs.datos_iPlanoles.validate(valid => {
          if (valid) {
            this.loading = true
            let request = {...this.iPlano}
            this.httpClient.getInstance().put(this.endpoint + '/' + request.id, request)
              .then(() => {
                Mensajes.success('Correcto', 'Datos guardados correctamente')
                this.$emit('refreshTable')
              })
              .catch(() => {
                Mensajes.error('Error', 'No fue posible guardar la información, contacte al administrador.')
              })
              .then(() => {
                this.loading = false
              })
          }
        })
      },
      initFormRules () {
        this.formRules = {
          name: [{required: false}]
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Consultas/FormPlanoSs2388.vue